"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSyncProviderImpl = void 0;
var Utils_1 = require("../../../utils/Utils");
var FirebaseUtils_1 = require("./../../firebase/FirebaseUtils");
var DataSyncProviderImpl = (function () {
    function DataSyncProviderImpl(cfg) {
        var _this = this;
        this.cfg = cfg;
        this.listeners = [];
        this.log = function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (_this.cfg.debuggable) {
                (_a = _this.cfg.logger).log.apply(_a, __spreadArray(["[".concat(_this.env, "] ").concat((0, Utils_1.getTimeString)(), " [Firebase] DataSyncProviderImpl#")], args, false));
            }
        };
        this.log('[Firebase] DataSyncProviderImpl# created!');
    }
    DataSyncProviderImpl.prototype.init = function (env, cfg) {
        this.env = env;
        if (cfg) {
            this.cfg = cfg;
        }
        return Promise.resolve();
    };
    DataSyncProviderImpl.prototype.setDebuggable = function (debuggable) {
        if (this.cfg) {
            this.cfg.debuggable = debuggable;
        }
    };
    DataSyncProviderImpl.prototype.stopAllMonitor = function () {
    };
    DataSyncProviderImpl.prototype.subscribe = function (tag, path, listener) {
        var _this = this;
        var dataSyncNode = {
            tag: tag,
            path: path,
            listener: listener
        };
        this.listeners.push(dataSyncNode);
        (0, FirebaseUtils_1.onNode)(path, function (data) {
            _this.log('subscribe# onChanged#', data);
            listener.onChanged(data.val());
        }, function () {
        });
        this.log('#subscribe#DataSyncNode List:', this.listeners);
        return Promise.resolve(dataSyncNode);
    };
    DataSyncProviderImpl.prototype.unsubscribe = function (node) {
        var _this = this;
        this.log('unsubscribe#node:', node);
        if (!node) {
            return Promise.resolve();
        }
        this.log('unsubscribe# DataSyncNode count - before:', this.listeners.length);
        var filteredList = this.listeners.filter(function (obj) { return obj.tag === node.tag; });
        if (!filteredList || filteredList.length === 0) {
            this.log('unsubscribe#node not found for tag:', node.tag);
            return Promise.resolve();
        }
        (0, FirebaseUtils_1.offNode)(node.path);
        filteredList.forEach(function (dataNote) {
            var index = _this.listeners.findIndex(function (dataNode) { return dataNode.tag === node.tag; });
            if (index !== -1) {
                _this.listeners.splice(index, 1);
            }
        });
        this.log('unsubscribe# remove:', filteredList);
        this.log('unsubscribe# DataSyncNode count:', this.listeners.length);
        return Promise.resolve();
    };
    DataSyncProviderImpl.prototype.clear = function () {
        var _this = this;
        var tmp = JSON.parse(JSON.stringify(this.listeners));
        tmp.forEach(function (obj) {
            _this.unsubscribe(obj)
                .then(function () {
                _this.log('clear#unsubscribe#:', obj);
            })
                .catch(function (err) {
                _this.log('clear#unsubscribe#:', err);
            });
        });
        this.listeners = [];
        return Promise.resolve();
    };
    DataSyncProviderImpl.prototype.list = function () {
        return Promise.resolve(this.listeners);
    };
    return DataSyncProviderImpl;
}());
exports.DataSyncProviderImpl = DataSyncProviderImpl;
//# sourceMappingURL=DataSyncProviderImpl.js.map